import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroEmailToCustomerSection', {
    requestFormTitle: 'Quote Details',
    emailToSupplierSectionName: 'Email to Customer',
    emailToSupplierReadonlySectionName: 'Email to Customer',
    emailToSupplierToggleLabel: 'Email approved Quotes automatically to the Customer',
    emailToSupplierAttachmentsLabel: 'Attachments to customer',
    emailToSupplierAttachmentsNote:
        'Please notice that the attachments added to the email would also be added to the Request created in Xero.',
    emailToSupplierAttachmentsFieldTitle: 'Attachments to customer',
});
